import { Row } from './row';
import styles from './styles.module.scss';
import type { Component } from './types';

export const GroupSection: Component = ({
  title,
  items,
}) => {
  const filteredItems = items.filter(item => item.show);
  if (filteredItems.length === 0) return null;
  return (
    <div className={styles.containerSubSection}>
      <div className={styles.textSubTitle}>
        {title}
      </div>
      <div className={styles.containerSubItems}>
        {items.map(item => (
          item.show && (
            <Row
              key={item.title}
              hasDesc={item.hasDesc}
              item={item}
              onClickDesc={item.onClickDesc} />
          )
        ))}
      </div>
    </div>
  );
};
